import { QueryClient } from '@tanstack/react-query'
import { offlineStorage } from '../services/offlineStorage'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount) => {
        // Don't retry if we're offline
        if (!navigator.onLine) return false
        // Retry up to 3 times for other errors
        return failureCount < 3
      },
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
      retry: (failureCount) => {
        if (!navigator.onLine) return false
        return failureCount < 3
      },
    },
  },
})

// Offline cache integration
export const createOfflineQuery = <T>(queryKey: string[], fetcher: () => Promise<T>) => {
  return async (): Promise<T> => {
    try {
      // Try to fetch from network first
      const data = await fetcher()
      
      // Cache the result offline
      await offlineStorage.saveData(
        queryKey.join('-'), 
        'query-cache',
        data as Record<string, unknown>
      )
      
      return data
    } catch (error) {
      // If network fails, try to get from offline cache
      const cachedData = await offlineStorage.getData(queryKey.join('-'))
      
      if (cachedData) {
        return cachedData as T
      }
      
      throw error
    }
  }
} 